// @ts-nocheck
import { NorvoAttribution } from '../brand/NorvoAttribution'
import { BrandedText, LANGS } from './public-data'
import { appLangToLocale } from '../../lib/public-route-locale'

// Localized label for the static KDP tool page (matches each page's <h1>).
const KDP_CALC_LABELS = {
  DA: 'KDP Royalty-beregner', EN: 'KDP Royalty Calculator', DE: 'KDP Tantiemen-Rechner',
  ES: 'Calculadora de regalías KDP', FR: 'Calculateur de redevances KDP', IT: 'Calcolatore royalty KDP',
  NL: 'KDP royalty-calculator', PL: 'Kalkulator tantiem KDP', PT: 'Calculadora de royalties KDP',
  SE: 'KDP royalty-kalkylator',
}

export const PublicFooter = ({ lc, navigate, onContact, onHelpCenter, onLanguages, lang }) => {
  const currentLang = LANGS.find((item) => item.code === lang) || LANGS[0]
  const goHomeAnchor = (id) => {
    if (window.location.pathname !== '/') {
      window.history.pushState({}, '', `/#${id}`)
      window.dispatchEvent(new PopStateEvent('popstate'))
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' }), 50)
      return
    }
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' })
  }
  const columns = [
    [lc.footerCols?.[0]?.[0] || 'Product', [
      [lc.footerCols?.[0]?.[1]?.[0] || 'How It Works', () => goHomeAnchor('how-it-works')],
      [lc.footerCols?.[0]?.[1]?.[1] || 'Pricing', () => goHomeAnchor('pricing')],
      [lc.footerCols?.[0]?.[1]?.[2] || 'Genres', () => goHomeAnchor('genres')],
      [`${currentLang.flag} ${lc.footerCols?.[0]?.[1]?.[3] || 'Languages'}`, onLanguages],
      [KDP_CALC_LABELS[lang] || KDP_CALC_LABELS.EN, null, `/${appLangToLocale(lang)}/tools/kdp-royalty-calculator`],
    ]],
    [lc.footerCols?.[1]?.[0] || 'Company', [
      [lc.footerCols?.[1]?.[1]?.[0] || 'About', () => navigate('/about')],
      [lc.footerCols?.[1]?.[1]?.[1] || 'Contact', onContact],
      [lc.footerCols?.[1]?.[1]?.[2] || 'Blog', () => navigate('/blog')],
    ]],
    [lc.footerCols?.[2]?.[0] || 'Support', [
      [lc.footerCols?.[2]?.[1]?.[0] || 'FAQ', () => navigate('/faq')],
      [lc.footerCols?.[2]?.[1]?.[1] || 'Help Center', onHelpCenter],
      [lc.footerCols?.[2]?.[1]?.[2] || 'Terms', () => navigate('/terms')],
      [lc.footerCols?.[2]?.[1]?.[3] || 'Privacy', () => navigate('/privacy')],
    ]],
  ]
  return (
    <footer className="bbg-footer">
      <div className="bbg-footer-brand">
        <button className="bbg-logo" onClick={() => navigate('/')} style={{ background: 'transparent', border: 0, padding: 0, cursor: 'pointer' }}>BookBuilder<span>Go</span></button>
        <p><BrandedText>{lc.footerBrand}</BrandedText></p>
      </div>
      <div className="bbg-footer-cols">
        {columns.map(([title, links]) => (
          <div key={title}>
            <h3>{title}</h3>
            {links.map(([label, action, href]) => href
              ? <a className="bbg-footer-link" href={href} key={label}>{label}</a>
              : <button className="bbg-footer-link" type="button" onClick={action} key={label}>{label}</button>)}
          </div>
        ))}
      </div>
      <div className="bbg-footer-bottom">
        <NorvoAttribution lang={lang} variant="footer" />
        <div className="bbg-socials" aria-label={lc.socials}>
          <a href="#top">𝕏</a><a href="#top">in</a><a href="#top">ig</a>
        </div>
      </div>
    </footer>
  )
}
